module.exports = __webpack_public_path__ + "static/posicionamiento1-dd45fede36c8af2f06d066dfe2827ce1.jpg";